import { JSX } from "react";

import { IconProps } from "@/@types/general.ts";

const IconPlay = (props: IconProps): JSX.Element => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
    <path d="M7.10864 20.7498C6.64774 21.0644 6.18084 21.0823 5.70795 20.8035C5.23598 20.5256 5 20.0963 5 19.5154V4.48502C5 3.90413 5.23598 3.47428 5.70795 3.19545C6.18084 2.9176 6.64774 2.93599 7.10864 3.25064L18.3778 10.7658C18.7926 11.0563 19 11.4677 19 12.0002C19 12.5327 18.7926 12.9441 18.3778 13.2346L7.10864 20.7498Z" />
  </svg>
);

export default IconPlay;
